var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToastGroup',_vm._l((_vm.toasts),function(toast){return _c('Toast',{key:toast.id,attrs:{"message":toast.message,"headline":toast.headline,"action-text":toast.actionText,"action":toast.action},on:{"after-leave":function($event){return _vm.handleAfterLeave(toast)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }